import { render, staticRenderFns } from "./MenuLinkItem.vue?vue&type=template&id=aa25fb68&scoped=true&"
import script from "./MenuLinkItem.vue?vue&type=script&lang=js&"
export * from "./MenuLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuLinkItem.vue?vue&type=style&index=0&id=aa25fb68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa25fb68",
  null
  
)

export default component.exports